import { Component, OnInit } from '@angular/core';
import { PoliciesStyleComponent } from "../policies-style/policies-style.component";
import { DocumentData } from '../../../interfaces/section';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-refund',
  standalone: true,
  imports: [PoliciesStyleComponent],
  templateUrl: './refund.component.html',
  styleUrl: './refund.component.scss'
})
export class RefundComponent implements OnInit {
  documentData!: DocumentData;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.load();
    this.translate.onLangChange.subscribe(() => this.load());
  }

  private load(): void {
    this.documentData = this.translate.instant('policies.refund');
  }
}
